<template>
  <div class="row">
    <div class="col-2">
      <div class="row">
        <div class="col"> {{ $t('importtask.labels.totalrecords') }} </div>
        <div class="col-4"> <span class="font-weight-bold" style="color:black;">{{data.TotalRecords}}</span> </div>
      </div>
      <div class="row">
        <div class="col">  {{ $t('importtask.labels.processedrecords') }} </div>
        <div class="col-4"> <span class="font-weight-bold" style="color:green;"> {{data.ProcessedRecords}}</span> </div>
      </div>
      <div class="row">
        <div class="col"> {{ $t('importtask.labels.failedrecords') }}  </div>
        <div class="col-4"> <span class="font-weight-bold" style="color:red;">{{data.FailedRecords}}</span> </div>
      </div>
      <div class="row">
        <div class="col"> {{ $t('importtask.labels.skippedrecords') }}  </div>
        <div class="col-4"> <span class="font-weight-bold" style="color:orange;">{{data.SkippedRecords}}</span> </div>
      </div>
    </div>
    <div class="col">
      <div class="row">
        <div class="col-6"> {{ $t('importtask.labels.processdate') }} </div>
        <div class="col"> {{ processDate }} </div>
      </div>
      <div class="row">
        <div class="col-6"> {{ $t('importtask.labels.duration') }} </div>
        <div class="col"> {{ data.ProcessDuration }} </div>
      </div>
      <div class="row">
        <div class="col-6"> {{ $t('importtask.labels.filename') }} </div>
        <div class="col"> <a href="javascript:void(0)" class="btn-link" @click="openFile">{{ data.Filename }}</a>  </div>
      </div>
      <div class="row">
        <div class="col-6"> {{ $t('importtask.labels.output_filename') }} </div>
        <div class="col"> <a href="javascript:void(0)" class="btn-link" @click="openOutputFile">{{ data.OutputFilename }}</a> </div>
      </div>
    </div>

    <div class="col">
      <div class="row">
        <div class="col-6"> {{ $t('importtask.seperators.decimal') }} </div>
        <div class="col"> {{ decimalSeperator }} </div>
      </div>
      <div class="row">
        <div class="col-6"> {{ $t('importtask.seperators.boolean') }} </div>
        <div class="col"> {{ booleanSeperator }} </div>
      </div>
      <div class="row">
        <div class="col-6"> {{ $t('importtask.seperators.datetime') }} </div>
        <div class="col"> {{ datetimeSeperator }} </div>
      </div>
      <div class="row">
        <div class="col-6"> {{ $t('importtask.labels.overwrite') }} </div>
        <div class="col"> {{ data.Overwrite ? $t('importtask.true'): $t('importtask.false')  }} </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import { booleanNotation, dateTimeNotation } from '@/components/Export/notations';
import { geturi } from 'libs/utils.js';
import { DecimalNotation } from '@/libs/enums';
export default {
  name: 'processed-import-detail',
  props: {
    data: {
      required: true
    }
  },
  data() {
    return {};
  },
  methods: {
    openFile(){
      let uri = geturi(`/mvc/import/GetFile?ImportId=${this.data.AutoID}&Result=false`);
      window.open(uri);
    },
    openOutputFile(){
      let uri = geturi(`/mvc/import/GetFile?ImportId=${this.data.AutoID}&Result=true`);
      window.open(uri);
    }
  },
  computed: {
    processDate(){
      if(this.data && this.data.ProcessDate){
        return this.data.ProcessDate;
      }
    },
    decimalSeperator(){
      if(this.data && this.data.DecimalFormat){
        return [
          {text: this.$t('importtask.notations.comma'), value: DecimalNotation.Comma},
          {text: this.$t('importtask.notations.dot'), value: DecimalNotation.Dot}
        ].find(x=>x.value === this.data.DecimalFormat).text;
      }
    },
    booleanSeperator(){
      if(this.data && this.data.BooleanFormat){
        return booleanNotation.find(x=>x.value === this.data.BooleanFormat).text;
      }
    },
    datetimeSeperator(){
      if(this.data && this.data.DateFormat){
        return dateTimeNotation.find(x=>x.value === this.data.DateFormat).text;
      }
    }
  }
};
</script>
